import { config } from 'src/constants';

import notification from './notification';
import logger from './logger';
import auth from './auth';

const getMiddlewares = () => {
  const middlewares = [auth, notification];

  if (config.isDevEnv) {
    middlewares.push(logger);
  }

  return middlewares;
};

export default getMiddlewares;
